import { Stack, Typography } from '@mui/material';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { toast, ToastContentProps } from 'react-toastify';
import { post } from '../../../lib/api';
import {
    useNotificationsDispatch,
    useNotificationsState
} from '../../../lib/contexts/NotificationsContext';
import { NotificationActionTypes } from '../../../lib/contexts/NotificationsContext/actions';
import { ErrorResponse } from '../../../lib/dtos/ErrorResponse';
import { generatePostData } from '../../../lib/helper/generate-notifications-post-data';
import { StyledGlobalSwitch } from '../../ConfigurePage.styles';

export type EmailNotificationProps = {
    shouldReceiveEmail: boolean;
    onSwitchToggle: (
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean
    ) => void | undefined;
};

const EmailNotification = () => {
    const context = useNotificationsState();
    const dispatch = useNotificationsDispatch();
    const [emailToggleDisabled, setEmailToggleDisabled] = useState(false);

    const onSwitchToggle:
        | ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void)
        | undefined = async (event, checkbox) => {
        setEmailToggleDisabled(true);
        const result = await toast.promise(
            post('notifications/edit/should-email', generatePostData.shouldReceiveEmail(checkbox)),
            {
                pending: 'Updating...',
                error: {
                    render: ({ data }: ToastContentProps<AxiosError<ErrorResponse>>) => {
                        return data?.response?.data.message;
                    },
                    autoClose: 5000
                },
                success: {
                    render: () => 'Successfully updated!',
                    autoClose: 5000
                }
            }
        );

        if (result.status === 200) {
            dispatch({
                type: NotificationActionTypes.UpdateData,
                payload: result.data
            });
            setEmailToggleDisabled(false);
        } else {
            setEmailToggleDisabled(false);
        }
    };

    return (
        <Stack gap={2} height={'100%'} justifyContent="space-between">
            <Stack direction={'row'} justifyContent={'space-between'}>
                <Typography fontSize={14} fontWeight={(t) => t.typography.fontWeightMedium}>
                    Email Notifications
                </Typography>
                <StyledGlobalSwitch
                    onChange={onSwitchToggle}
                    checked={context.shouldReceiveEmail}
                    disabled={emailToggleDisabled}
                />
            </Stack>
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'baseline'}>
                <Stack direction={'row'} alignItems={'baseline'} gap={1}>
                    <Typography fontSize={16} fontWeight={(t) => t.typography.fontWeightBold}>
                        Email:
                    </Typography>
                    <Typography
                        fontSize={14}
                        fontWeight={(t) => t.typography.fontWeightMedium}
                        sx={{ wordBreak: 'break-word' }}>
                        {context.userName}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default EmailNotification;
